import { constants as config } from '@config';

module.exports = {
  placeHolderUrl: 'https://static.inkive.com/assets/img/placeholders/imageplaceholder_new.svg',

  mapResult: function (item) {
    this.canvas = INKIVE.Tool.getInstance().editor.canvas;

    item = item._source;
    const photos = item.photos || [];
    const structure = item.structure || {};
    const location = item.location || {};
    const listAgent = item.list_agent_office || {};
    const coListAgent = item.co_list_agent_office || {};
    const virtualTours = item.virtual_tours || {};
    const openHouses = item.open_houses || {};
    let parking = structure.parking_features && structure.parking_features.join(', ') || '';
    if (structure.parking_total) {
      parking += parking ? ' / ' : '';
      parking += structure.parking_total;
    }

    const listAddress = item.list_address || {};
    const propertyAddress = item.property_address || {};

    return {
      id: item.list_key,
      list_key: item.list_key,
      list_uuid: item.list_uuid,
      address: listAddress.full_street_address || propertyAddress.full_street_address,
      city: listAddress.city || propertyAddress.city,
      state: listAddress.state_prov || propertyAddress.state_prov_short,
      postal_code: listAddress.postal_code || propertyAddress.postal_code,
      photos,
      thumbnail: photos[0] ? photos[0].ph_url : this.placeHolderUrl,

      text: {
        list_key: item.list_key,
        listing_category: item.list_category,
        listing_status: item.list_status,
        property_type: item.prop_type,
        property_sub_type: item.prop_subtype,
        special_condition: item.special_list_condition,
        listing_address: this.getAttribute(item, 'listing_address'),
        property_address: this.getAttribute(item, 'list_address'),
        listing_type: item.list_type,
        mls_name: item.mls_name,
        current_price: this.getAttribute(item, 'current_list_price'),
        original_price: this.getAttribute(item, 'original_list_price'),
        sold_price: this.getAttribute(item, 'close_price'),
        listing_date: this.getAttribute(item, 'list_dt'),
        contract_day: this.getAttribute(item, 'contract_expiry_dt'),
        settled_date: this.getAttribute(item, 'close_dt'),
        // 13. “Days on Market”
        year_built: item.year_built,
        living_area: this.getAttribute(item, 'living_area'),
        lot_size: this.getAttribute(item, 'lot_size_area'),
        bedrooms: item.total_bed,
        bathrooms: item.total_bath,
        half_bathrooms: item.half_bath,
        full_bathrooms: item.full_bath,
        stories: structure.stories,
        parking,
        basement_description: item.basement_desc,
        cooling_heating_system: structure.heating_cooling && structure.heating_cooling.join(', '),
        hoa_fees: item.hoa && item.hoa.assoc_fee,
        schools: location.schools && _.compact(_.map(location.schools, 'school_category')).join(', '),
        schools_names: location.schools && _.compact(_.map(location.schools, 'school_name')).join(', '),
        schools_districts: location.schools && _.compact(_.map(location.schools, 'school_district')).join(', '),
        market_center: item.brokerage && item.brokerage.name,
        listing_agent: item.list_kw_uid,
        listing_agent_name: listAgent.list_agent_full_name,
        colist_agent: coListAgent.co_list_agent_full_name,
        /*
        35. "Latitude" - Location.Coordinates.lat
        36. "Longitude" - Location.Coordinates.lon
         */
        interior_feature_list: this.getBooleanListAttribute(structure.interior_features),
        exterior_feature_list: this.getBooleanListAttribute(structure.exterior_features),
        views_description: structure.views && structure.views.join(', '),
        property_description: item.list_desc,
        virtual_tour_url: virtualTours.vt_url,
        virtual_tour_description: virtualTours.vt_short_desc,
        open_houses_description: openHouses.oh_desc,
        open_houses_status: openHouses.oh_status,
        open_houses_start_date: this.getAttribute(openHouses, 'oh_start_dt'),
        open_houses_end_date: this.getAttribute(openHouses, 'oh_end_time_dt')
      }
    };
  },

  getBooleanListAttribute: function (items) {
    return _.compact(_.map(items, function (elem, key) {
      return elem && key.replace('_', ' ');
    })).join(', ');
  },

  getAttribute: function (item, attribute) {
    const keys = attribute.split('_');
    let result;

    if (!item[attribute]) {
      return;
    }

    if (_.contains(keys, 'price')) {
      const currency = item.currency_code;
      result = Number(item[attribute]).toLocaleString();

      if (currency) {
        result += ' ' + currency;

        if (_.contains(['USD', 'AUD'], currency)) {
          result = '$' + result;
        }
      }
    }

    if (_.contains(keys, 'area')) {
      const units = item[attribute + '_units'] || item[attribute.replace('area', 'units')];

      result = item[attribute];

      if (units) {
        result += ' ' + units;
      }
    }

    if (_.contains(keys, 'dt')) {
      result = item[attribute].length > 10 ? item[attribute].substr(0, 10) : item[attribute];
    }

    if (_.contains(keys, 'address')) {
      const address = item[attribute].full_street_address || '';
      const city = item[attribute].city || item[attribute].city_short || item[attribute].city_long || '';
      const postalCode = item[attribute].postal_code || item[attribute].postal_code_short || '';

      result = address + '. ' + city + ' - ' + postalCode;
    }

    return result;
  },

  showPropertyImages: function ($container, parent) {
    const deferred = $.Deferred();
    const photos = parent.itemDetails.photos;

    $container.append('<div class="thumbnail-wrapper"/>');

    if (!photos.length) {
      $container.html('<label class="title text-center">' +
        INKIVE.TranslateHelper.translate('general.no_results') +
        '</label>');
    }

    const callback = function (thumb, $wrapper) {
      INKIVE.Modal.loaderClose($container);
      _.bind(parent.tool.callbackImages, parent.tool)(thumb, $wrapper);

      $(thumb).each(function () {
        const $thumb = $(this);
        $thumb.attr('data-search-filter', $thumb.find('a').attr('data-original-title'));
      });

      $wrapper.find('.thumbnail-wrapper').masonry(config.sidebar.thumbnail.masonryConfig);
      parent.refreshAntiscroll();
    };

    const thumbs = _.map(photos, function (photo) {
      INKIVE.ImagesFactory.addImageData(photo.ph_url);

      return {
        id: 'photo-mls-details-' + photo.ph_order,
        width: 120,
        data: {
          version: {
            thumb: photo.ph_url,
            original: photo.ph_url

          },
          tags: _.map(photo.ph_tags, 'tag_name'),
          name: photo.ph_label && photo.ph_label.name.toLowerCase()
        }
      };
    });

    parent.tool.addThumbItem($container, thumbs, callback);

    return deferred.promise();
  },

  showPropertyTexts: function ($container, parent) {
    const showReplaceButton = $(this.getSelectedElement()).is('.textarea');
    const onlyReplace = parent.canUseText === 'onlyReplace';

    INKIVE.Modal.loaderClose($container);
    _.each(parent.itemDetails.text, _.bind(function (text, key) {
      if (text) {
        key = key.replace(/_/g, ' ');
        text = (text + '').replace(/"/g, '&quot;');

        const $textThumbContainer = $('<div class="thumbnail-wrapper no-resizable" ' +
          'data-search-filter="' + text.toLowerCase() + key + '"/>');

        const thumb = new INKIVE.ThumbText({
          text,
          width: 230,
          fontFamily: 'Lato'
        });
        const replaceText = _.bind(_.partial(this.onReplaceText, thumb), this);

        thumb.appendTo($textThumbContainer);

        const $button = $('<div class="description">' + key + '</div>' +
          '<div class="icons">' +
          (onlyReplace ? '' : '<i class="desygner-icon-plus add-text stand-alone"/>') +
          '<i class="fa fa-refresh replace-text ' + (showReplaceButton ? '' : 'hidden') + '"/>' +
          '</div>');

        $textThumbContainer.append($button);

        $textThumbContainer.appendTo($container);
        $textThumbContainer.find('i.desygner-icon-plus').on('click', _.bind(thumb.onItemClick, thumb));
        $textThumbContainer.find('i.replace-text').on('click', replaceText);

        onlyReplace && $textThumbContainer.find('.thumbnail').off('mousedown').on('click', replaceText);
      }
    }, this), parent);

    parent.refreshAntiscroll();
  },

  onReplaceText: function (thumb) {
    const element = this.getSelectedElement();

    if ($(element).is(':not(.textarea)')) {
      return;
    }
    const textarea = new INKIVE.Text.Textarea().setDOM(element);

    textarea.text.setValues({ textContent: thumb.text });
    textarea.render(this.canvas);
  },

  getSelectedElement: function () {
    const elems = this.canvas.getSelectedElems();

    return elems.length && elems[0];
  }
};
